<template>
    <div class="mt-6 flex items-center justify-between">
        <div class="text-gray-800">
            <i18n-t
                keypath="giftCardWithToken"
                scope="global"
                tag="div"
            >
                <template #token>
                    <span class="text-gray-600">{{ giftCard.token }}</span>
                </template>
            </i18n-t>

            <div class="grid grid-cols-2 gap-x-4 pl-2 text-sm text-gray-500">
                <div>{{ t('checkoutSections.currentBalance') }}</div>
                <div>
                    {{ currentBalance }}
                </div>
                <div>{{ t('checkoutSections.balanceAfterPayment') }}</div>
                <div>
                    {{ balanceAfterPayment }}
                </div>
            </div>

            <prime-button
                :label="t('checkoutSections.remove')"
                class="ml-2 !p-0"
                link
                size="small"
                severity="danger"
                :disabled="isProcessing"
                @click="$emit('remove')"
            />
        </div>

        <div>
            {{ balanceToUseFormatted }}
        </div>
    </div>
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import type { GiftCardPaymentInfo } from '~/components/Checkout/Sections/PaymentInformation.vue'
import { computed } from 'vue'
import { Decimal } from '~/composables/support/decimal'
import { useCheckoutFormProcessing } from '~/components/Checkout/Forms/use-checkout-form'
import { I18nT, useI18n } from 'vue-i18n'

const props = defineProps<{
    giftCard: GiftCardPaymentInfo
}>()

defineEmits<{
    (e: 'remove'): void
}>()

const { t } = useI18n({ useScope: 'global' })

const { isProcessing } = useCheckoutFormProcessing()

const currentBalance = computed(() => {
    return new Decimal(props.giftCard.currentBalance).formatCurrency()
})

const balanceAfterPayment = computed(() => {
    return new Decimal(props.giftCard.currentBalance)
        .minus(new Decimal(props.giftCard.amount))
        .formatCurrency()
})

const balanceToUseFormatted = computed(() => {
    return new Decimal(props.giftCard.amount)
        .invertSign()
        .formatCurrency(2, false)
})
</script>
